import { useState, useEffect, useCallback } from 'react';

interface UseFormCloseProtectionResult {
  showConfirm: boolean;
  handleCloseAttempt: () => void;
  handleConfirmClose: () => void;
  handleCancelClose: () => void;
}

export function useFormCloseProtection(
  isDirty: boolean,
  onClose: () => void
): UseFormCloseProtectionResult {
  const [showConfirm, setShowConfirm] = useState(false);

  // Browser tab close protection
  useEffect(() => {
    if (!isDirty) return;

    const listener = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', listener);
    return () => window.removeEventListener('beforeunload', listener);
  }, [isDirty]);

  const handleCloseAttempt = useCallback(() => {
    if (isDirty) {
      setShowConfirm(true);
    } else {
      onClose();
    }
  }, [isDirty, onClose]);

  const handleConfirmClose = useCallback(() => {
    setShowConfirm(false);
    onClose();
  }, [onClose]);

  const handleCancelClose = useCallback(() => {
    setShowConfirm(false);
  }, []);

  return {
    showConfirm,
    handleCloseAttempt,
    handleConfirmClose,
    handleCancelClose,
  };
}
